// Какие маркеры вершин оставить, убрать и создать при синхронизации с линией.
// Сигнатура маркера (null - вершина без маркера) складывается из индекса,
// координаты, роли (старт/финиш/обычная) и режима: совпала - маркер остаётся.
// При тапе пересоздаются два маркера (бывший финиш и новый), а не все.
export interface VertexMarkerPlan {
  remove: number[];
  create: number[];
}

export function planVertexMarkers(prev: (string | null)[], next: (string | null)[]): VertexMarkerPlan {
  const remove: number[] = [];
  const create: number[] = [];
  const n = Math.max(prev.length, next.length);
  for (let i = 0; i < n; i++) {
    const p = i < prev.length ? prev[i] : null;
    const q = i < next.length ? next[i] : null;
    if (p === q) continue;
    if (p != null) remove.push(i);
    if (q != null) create.push(i);
  }
  return { remove, create };
}
